import { ShieldCheck } from "lucide-react";
import { useSettings } from "@/lib/useSettings";
import { fileUrl } from "@/lib/api";

export default function KopSurat({ settings: override }) {
  const fetched = useSettings();
  const s = override || fetched || {};
  const logoSrc = s.logo_file ? fileUrl(s.logo_file) : "/logo-seruyan.webp";

  return (
    <div className="kop-surat" data-testid="kop-surat">
      <div className="flex items-center gap-4 pb-2">
        <div className="shrink-0 w-24 h-24 flex items-center justify-center bg-white overflow-hidden">
          <img src={logoSrc} alt="Logo" className="w-full h-full object-contain" />
        </div>
        <div className="flex-1 text-center">
          <div className="text-sm md:text-base font-bold uppercase tracking-wide">
            {s.pemerintah_header || "Pemerintah Kabupaten Seruyan"}
          </div>
          <div className="text-lg md:text-xl font-bold uppercase tracking-wider">
            {s.institution_name || "Sekretariat Dewan Perwakilan Rakyat Daerah"}
          </div>
          <div className="text-xl md:text-2xl font-black uppercase tracking-wider">
            {s.kabupaten_name || "Kabupaten Seruyan"}
          </div>
          <div className="text-xs md:text-sm mt-1">{s.alamat || ""}</div>
          <div className="text-xs md:text-sm">{s.kontak || ""}</div>
        </div>
      </div>
      <div className="divider" />
    </div>
  );
}
